import { ENV } from './env'
const ENVDEV = {
  ...ENV,
  env: 'DEVELOPMENT'
}
// if (typeof window !== 'undefined') window.ENV = ENVDEV
export default ENVDEV
